import { useMemo } from 'react';
import { useQuery } from '@apollo/client';

// constants
import { CONSULT_TOPIC } from 'constants/consults';
import { topicOptions, topicOptionsUPP } from './helpers';

// helpers
import { GET_ORDERS, GET_ORDERS_UPP } from '../../queries';

// types
import { useFeatureFlags } from '../../../../helpers/hooks';

export function useGetOrders() {
  const { uppPrenatalResultsEnabled } = useFeatureFlags();

  return useQuery(GET_ORDERS_UPP, {
    fetchPolicy: 'cache-and-network',
    variables: { myriskOnly: !uppPrenatalResultsEnabled },
  });
}

export function useHasOrders() {
  const { data, loading, error, refetch } = useQuery(GET_ORDERS);

  // Data is not yet available and loading
  if (!data && loading) {
    return false;
  }

  // Data has loaded and is not an empty list
  if (
    data?.orders?.__typename === 'OrdersListSuccess' &&
    data?.orders?.ordersList?.length
  ) {
    return true;
  }

  // Retry failed requests
  if (error && !loading) {
    refetch();

    return false;
  }

  // Patient has no orders
  return false;
}

export function useAvailableTopicOptions() {
  const hasOrders = useHasOrders();
  const { uppConsultsEnabled } = useFeatureFlags();
  const availableOptions = useMemo(() => {
    // Patient needs CustomerProfile ID in order to schedule all but MyRisk consults
    if (hasOrders || uppConsultsEnabled) {
      return uppConsultsEnabled ? topicOptionsUPP : topicOptions;
    }

    // Patient can only schedule MyRisk consult
    const filteredTopicOptions = [
      {
        label: CONSULT_TOPIC.myRisk.label,
        value: CONSULT_TOPIC.myRisk.value,
      },
    ];

    return filteredTopicOptions;
  }, [hasOrders, uppConsultsEnabled]);

  return availableOptions;
}
